import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import BroadcastScheduleControl from '../../containers/LiveTV/BroadcastScheduleControl';
import LiveTVChannelList from '../../containers/LiveTV/LiveTVChannelList';
// import NewVideo from "./../../containers/LiveTV/NewVideo";
import Loader from '../Loader';

class LiveTV extends Component {

    constructor() {
        super();
        this.state = {
            lightOff: false
        }
    }

    handleToggleLight = () => {
        let isTurnOff = this.state.lightOff;
        this.setState({
            lightOff: !isTurnOff
        })
    }

    render() {
        if (this.props.channel.loading) return <Loader/>;
        if (this.props.channel.error) return 'Error fetch data';

        let data = this.props.channel.channel;

        if (data === null) {
            return <Redirect to="/livetv/quoc-hoi"/>
        }

        return (
            <div>
                <div className="detail-tv">
                    <div className="top">
                        <div className="container">
                            <div className="clearfix">
                                <div className={this.state.lightOff ? 'tv-here livetv-light-off' : 'tv-here livetv-light-on'}>
                                    <div className="frame">
                                        <iframe title="LiveTV" src={data.source} width="100%" height="100%" frameBorder="0" scrolling="no" allowFullScreen="true" />
                                    </div>
                                    <div className="action-wrap clearfix">
                                        <div className="name">{data.description}</div>
                                        <div className="pull-right">
                                            <span className="action-btn" role="button" onClick={this.handleToggleLight}>
                                                <img src="/images/btn-light.png" alt=""/>
                                                {this.state.lightOff ? 'Bật đèn' : 'Tắt đèn'}
                                            </span>
                                            <span className="action-btn" role="button">
                                                <img src="/images/btn-eye.png" alt=""/>
                                                Tắt quảng cáo
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className={this.state.lightOff ? "overlay" : ''}></div>
                                {this.state.lightOff ? '' : <BroadcastScheduleControl channel={data.slug} schedule_id={data.schedule_id} />}
                            </div>
                        </div>
                    </div>
                    <div className={this.state.lightOff ? "mainct light-body-off" : "mainct"} >
                        <LiveTVChannelList/>
                        {/* <NewVideo /> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default LiveTV



// WEBPACK FOOTER //
// ./src/components/LiveTV/LiveTV.js